import {
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  ERROR_COLORS,
  GRAY_COLORS,
  INFO_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS,
  WARNING_COLORS
} from 'asterX-UI'
import ChipStandard from 'asterX-UI/DataDisplay/ChipStandard'
import {
  ArrowRightIcon,
  CheckCircleIcon,
  KebabVerticalIcon
} from 'asterX-UI/Icons'
import ChevronLeftIcon from 'asterX-UI/Icons/ChevronLeftIcon'
import KeyIcon from 'asterX-UI/Icons/KeyIcon'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Modal } from 'asterX-UI/Modals'
import { KEY_STATUSES, KEY_STATUSES_COLORS } from 'constants/keyStatuses'
import { useResErrors } from 'hooks'
import { CarService, SalesService } from 'lib/api'
import { useEffect, useState } from 'react'

import { FieldInfoNG } from 'asterX-UI/DataDisplay'
import Car360View from 'components/Car360View'
import CarInspection from 'components/Desktop/Car/CarInspection'
import DiscountModal from 'components/Desktop/Car/DiscountModal'
import OptionsModal from 'components/Desktop/Car/OptionsModal'
import OrdersModal from 'components/Desktop/Car/OrdersModal'
import MobilePhotoSlider from 'components/Desktop/PhotoSlider/MobilePhotoSlider'
import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'
import PriceGraphicsModal from 'components/PriceGraphics/PriceGraphicsModal'
import { useAuthStore } from 'context/AuthStore'
import moment from 'moment'

import ActionModal from 'asterX-UI/Modals/ActionModal'
import CarTechStateModal from 'components/CarTechStateModal/CarTechStateModal'
import { SPP } from 'constants/roles'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { guaranteeKeysName, parseJson } from 'lib/utils'
import BonusHistory from './BonusHistory'
import { TiresModal } from './TiresModal'
import { UnFrozeModal } from './UnFrozeModal'
import { DownloadIcon } from 'asterX-UI/Icons/DownloadIcon'
import { Button } from '@material-ui/core'
import useDownloadPDF from 'hooks/useDownloadPDF'
import { useCarContext } from 'context/carStore'
import { TireService } from 'lib/api/services/TireService'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    fontSize: 16,
    marginBottom: 10
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column'
  },

  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px'
  },
  namePrice: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginRight: 'auto'
  },
  price: {
    padding: '0 10px',
    borderRadius: 5,
    backgroundColor: WARNING_COLORS['300']
  },
  discount: {
    padding: '0 10px',
    textDecoration: 'line-through'
  },
  kebab: {
    transform: 'rotate(90deg)'
  },
  slider: {
    position: 'relative',
    maxHeight: 250,
    marginBottom: 22
  },
  slide: {
    transform: 'translateY(-20%)'
  },
  img: {
    width: '100%',
    height: 200,
    objectFit: 'cover'
  },
  branch: {
    padding: '2px 8px',
    backgroundColor: 'rgba(234, 236, 240, 0.80)',
    borderRadius: 16,
    color: GRAY_COLORS['700'],
    fontWeight: 500
  },
  vinStatus: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 10
  },
  keyStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '2px 8px',
    borderRadius: 16,
    backgroundColor: SUCCESS_COLORS['50'],
    color: SUCCESS_COLORS['700']
  },
  keyIcon: {
    fontSize: 14
  },
  specs: {
    marginBottom: 10,
    borderRadius: 100
  },
  separator: {
    width: '100%',
    border: '1px solid' + GRAY_COLORS['200'],
    marginBottom: 22
  },
  description: {
    overflowWrap: 'break-word',
    marginBottom: 12,
    marginTop: 12
  },
  checkResult: {
    display: 'flex',
    cursor: 'pointer',
    gap: 10,
    color: PRIMARY_COLORS['700'],
    fontWeight: 600
  },
  buttons: {
    position: 'absolute',
    bottom: 0,
    width: '100%'
  },
  row: {
    display: 'flex',
    gap: 10
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  vin: {
    color: GRAY_COLORS[500]
  },
  tires: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 22
  },
  checkIcon: {
    marginRight: 5,
    padding: 0,
    color: 'green'
  }
}))
const infoRopStyle = {
  labelStyle: {
    width: 200
  },
  rootStyle: {
    alignItems: 'center'
  }
}

const CheckBoxList = ({ data }) => {
  const checkboxState = value => {
    if (typeof value === 'boolean') {
      return value
    }
    if (typeof value === 'object' && value !== null) {
      return Object.values(value).some(subValue => subValue)
    }
    return false
  }
  return (
    <Grid
      item
      container
      direction="column"
      spacing={1}
      style={{ marginBottom: 15 }}
    >
      <FormControl>
        <FormGroup>
          {Object.entries(data || {}).map(
            ([key, value]) =>
              key !== 'audit' && (
                <Grid item style={{ paddingLeft: 10 }} key={key}>
                  {checkboxState(value) && (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkboxState(value)}
                            name={key}
                            color="primary"
                          />
                        }
                        label={guaranteeKeysName(key)}
                      />
                      <Divider />
                    </>
                  )}
                  {typeof value === 'object' &&
                    key !== 'audit' &&
                    Object.entries(value).map(([subKey, subValue]) => (
                      <Grid item style={{ paddingLeft: 20 }} key={subKey}>
                        {subValue && (
                          <>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={subValue}
                                  name={subKey}
                                  color="primary"
                                />
                              }
                              label={guaranteeKeysName(subKey)}
                            />
                            <Divider />
                          </>
                        )}
                      </Grid>
                    ))}
                </Grid>
              )
          )}
        </FormGroup>
      </FormControl>
    </Grid>
  )
}

const CarData = ({
  vin,
  carForSale,
  keyCode,
  demonstrationResults,
  isSelected = false,
  onClose = () => {}
}) => {
  const { standardCheck } = useResErrors()
  const {
    store: { tiresId }
  } = useSelectionStore()

  const [car, setCar] = useState(null)
  const [loading, setLoading] = useState(null)
  const classes = useStyles()
  const [open, setOpen] = useState({
    techState: false,
    guarantee: false,
    inspectionResult: false,
    priceGraphics: false
  })
  const [guaranteeCp, setGuaranteeCp] = useState(null)
  const [tireSet, setTireSet] = useState(null)
  const { setTechState, setCar: setCarInContext } = useCarContext()
  const { downloadInspectionReport } = useDownloadPDF()
  const handleEngineCapacity = volume => {
    return Number(Number(volume || 0) / 1000).toFixed(1)
  }

  const handleOpen = (key, value) => () =>
    setOpen(prevState => ({ ...prevState, [key]: value }))

  useEffect(() => {
    getCarByVin()
    getWorkOrdersByVin()
    getGuaranteeCp()
    return () => {}
  }, [])

  useEffect(() => {
    const fetchTireSet = async () => {
      const res = await TireService.getRimsBySetId(tiresId)
      setTireSet(res.data)
    }
    fetchTireSet()
  }, [tiresId])

  const getCarByVin = async () => {
    setLoading(true)

    await CarService.getCarByVin(vin).then(response =>
      standardCheck(response, () => {
        setCar(response.data)
        setCarInContext(response.data)
      })
    )

    setLoading(false)
  }

  const getWorkOrdersByVin = async () => {
    setLoading(true)
    await SalesService.getWorkOrdersByVin(vin).then(res =>
      standardCheck(res, () => {})
    )
    setLoading(false)
  }
  const totalPrice =
    tireSet && tireSet[0]?.tireSet?.price
      ? tireSet[0]?.tireSet?.price + car?.price
      : car?.price

  const getGuaranteeCp = async () => {
    setLoading(true)

    return new Promise((resolve, reject) => {
      CarService.getCarValueByVin(vin).then(response => {
        setLoading(false)

        standardCheck(
          response,
          () => {
            const data = parseJson(response?.data?.value, {})

            data?.guarantee_cp && setGuaranteeCp(data?.guarantee_cp)
            setTechState(data)
          },
          {
            onFail: () => reject('err')
          }
        )
      })
    })
  }

  return car ? (
    <PageContainerDesktop
      disablePaddings={isSelected}
      style={{ height: isSelected ? '100%' : '95vh' }}
      {...(!isSelected
        ? {
            customHeader: (
              <Header
                onClose={onClose}
                car={car}
                carForSale={carForSale}
                handleOpen={handleOpen}
              />
            )
          }
        : {})}
    >
      <div className={classes.container}>
        <MobilePhotoSlider
          photos={
            car.photos
              ? car.photos
              : ['/static/media/car_placeholder.32a813e395be6b938a41.jpg']
          }
          className={classes.slider}
          slideClassName={classes.slide}
        ></MobilePhotoSlider>

        {isSelected && (
          <Header
            isSelected
            car={car}
            carForSale={carForSale}
            handleOpen={handleOpen}
          />
        )}

        <div className={classes.row} style={{ marginBottom: 10 }}>
          <div className={classes.branch}>{car?.branch?.name}</div>

          {car.hasOwnProperty('carStatus') && (
            <ChipStandard
              {...(car?.carStatus?.code === 'available'
                ? {
                    color: SUCCESS_COLORS[700],
                    backgroundColor: SUCCESS_COLORS[50]
                  }
                : car?.carStatus?.code === 'reserved'
                ? {
                    color: ERROR_COLORS[700],
                    backgroundColor: ERROR_COLORS[50]
                  }
                : {
                    color: GRAY_COLORS[700],
                    backgroundColor: GRAY_COLORS[50]
                  })}
            >
              {car?.carStatus?.name}
            </ChipStandard>
          )}

          {(car.hasOwnProperty('carbazar') ||
            car.hasOwnProperty('autoDiscount')) && (
            <ChipStandard
              {...(car.carbazar
                ? {
                    color: ERROR_COLORS[700],
                    backgroundColor: ERROR_COLORS[70]
                  }
                : car.autoDiscount
                ? {
                    color: INFO_COLORS[700],
                    backgroundColor: INFO_COLORS[100]
                  }
                : {
                    color: GRAY_COLORS[700],
                    backgroundColor: GRAY_COLORS[70]
                  })}
            >
              {car?.carbazar ? 'Карбазар' : 'Астер'}
            </ChipStandard>
          )}

          {!!car?.cashback && (
            <ChipStandard
              color={ERROR_COLORS[700]}
              backgroundColor={ERROR_COLORS[50]}
            >
              Купить за бонус
            </ChipStandard>
          )}

          {car?.cpTransactionType && (
            <ChipStandard
              color={INFO_COLORS[700]}
              backgroundColor={INFO_COLORS[100]}
            >
              {[
                'Комиссия',
                'Комиссионное оформление',
                'Комиссия в залоге',
                'Com-trade',
                'Зачет COMTRADE',
                'Doscar COMTRADE'
              ].includes(car?.cpTransactionType)
                ? car?.cpTransactionType
                : 'Выкуп'}
            </ChipStandard>
          )}
        </div>

        <div className={classes.vinStatus}>
          <div className={classes.vin}>{car.vin}</div>
          {keyCode && (
            <ChipStandard {...KEY_STATUSES_COLORS?.[keyCode]}>
              <KeyIcon className={classes.keyIcon} />{' '}
              {KEY_STATUSES?.[keyCode] || '-'}
            </ChipStandard>
          )}
        </div>
        <div className={classes.specs}>{`${
          car.mileage ? car.mileage.toString().thousandSeparator() : '0'
        } км, ${
          car.engineCapacity ? handleEngineCapacity(car.engineCapacity) : '0'
        } (${car.engineType ? car.engineType.name.toLowerCase() : ''}), ${
          car.dwheelType ? car.dwheelType.name.toLowerCase() : ''
        } привод, ${car.transmission === 1 ? 'автомат,' : 'механика,'} ${
          car.bodyType?.name || ''
        }, ${car.color?.name || ''}, руль ${
          car.steering === 1 ? 'левый' : 'правый'
        }, Закуп.: ${car.buyerFullName}`}</div>

        {tiresId && (
          <div className={classes.tires}>
            <IconButton className={classes.checkIcon}>
              <CheckCircleIcon />
            </IconButton>
            {`Добавлен номер комплекта шин - ${tiresId}`}
          </div>
        )}

        <div className={classes.separator}></div>

        <div className={classes.row}>
          <div className={classes.column} style={{ width: '40%' }}>
            <FieldInfoNG label={'Цена без скидки:'} {...infoRopStyle}>
              {`${car?.price?.toString()?.thousandSeparator() || '-'} ₸`}
            </FieldInfoNG>
            {car?.acceptanceDate && (
              <FieldInfoNG label={'На стоке:'} {...infoRopStyle}>
                {moment(new Date()).diff(
                  moment(car?.acceptanceDate, 'YYYY-MM-DD'),
                  'days'
                ) + ' дней' || '-'}
              </FieldInfoNG>
            )}
            {car?.discountAmount && (
              <FieldInfoNG label={'Сумма скидки:'} {...infoRopStyle}>
                {`${
                  car.discountAmount?.toString()?.thousandSeparator() || '-'
                } ₸`}
              </FieldInfoNG>
            )}{' '}
            {car?.discountMargin && (
              <FieldInfoNG label={'Сумма наценки:'} {...infoRopStyle}>
                {`${
                  car.discountMargin?.toString()?.thousandSeparator() || '-'
                } ₸`}
              </FieldInfoNG>
            )}
          </div>
        </div>
        <div className={classes.separator} style={{ marginTop: 10 }} />
        {tireSet && (
          <>
            <div className={classes.row}>
              <div className={classes.column} style={{ width: '40%' }}>
                <FieldInfoNG label={'Марка шины:'} {...infoRopStyle}>
                  {tireSet[0]?.tireSet?.mark?.name || '-'}
                </FieldInfoNG>
                <FieldInfoNG label={'Модель шины:'} {...infoRopStyle}>
                  {tireSet[0]?.tireSet?.model?.name || '-'}
                </FieldInfoNG>
                <FieldInfoNG label={'Цена за комплект:'} {...infoRopStyle}>
                  {tireSet[0]?.tireSet?.price
                    ?.toString()
                    ?.thousandSeparator() || '-'}{' '}
                  ₸
                </FieldInfoNG>
              </div>
            </div>
            <div className={classes.separator} style={{ marginTop: 10 }} />
            <div style={{ paddingBottom: 10 }}>
              <FieldInfoNG label={'Итоговая стоимость:'} {...infoRopStyle}>
                {totalPrice.toLocaleString()?.thousandSeparator() || '-'} ₸
              </FieldInfoNG>
            </div>
            <div className={classes.separator} style={{ marginTop: 10 }} />
          </>
        )}

        <div className={classes.description}>{car.description}</div>

        {!!demonstrationResults && (
          <div
            className={classes.checkResult}
            onClick={handleOpen('inspectionResult', true)}
          >
            Результат осмотра <ArrowRightIcon className={classes.arrowIcon} />
          </div>
        )}
      </div>

      <Button
        color="primary"
        variant="contained"
        size="small"
        onClick={downloadInspectionReport}
        style={{ margin: '30px 0' }}
        endIcon={<DownloadIcon />}
      >
        Акт техсостояния
      </Button>

      {open.techState && (
        <CarTechStateModal
          open={open.techState}
          car={car}
          vin={car.vin}
          onClose={handleOpen('techState', false)}
        />
      )}

      <ActionModal
        title="Информация по Гарантии"
        open={open.guarantee}
        onClose={handleOpen('guarantee', false)}
      >
        <CheckBoxList data={guaranteeCp} />
      </ActionModal>

      {open?.inspectionResult && (
        <Modal
          open={open?.inspectionResult}
          fullWidth
          onClose={handleOpen('inspectionResult', false)}
        >
          <CarInspection
            isDisabled
            title={`${car.marka.name} ${car.model.name} ${car.year}`}
            onClose={handleOpen('inspectionResult', false)}
            initialData={demonstrationResults}
          />
        </Modal>
      )}

      {open.priceGraphics && (
        <PriceGraphicsModal
          open={open.priceGraphics}
          car={car}
          onClose={handleOpen('priceGraphics', false)}
        />
      )}
    </PageContainerDesktop>
  ) : (
    <LoaderBackdrop loading={loading} />
  )
}

export default CarData

const Header = ({
  onClose = () => {},
  carForSale,
  isSelected,
  car,
  handleOpen
}) => {
  const {
    authStore: { user }
  } = useAuthStore()

  const { funcs } = useSelectionStore()
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [isDiscountModalOpen, setIsDiscountModalOpen] = useState(false)
  const [isSppOpenModal, setIsSppOpenModal] = useState(false)
  const [isOptionsModalOpen, setIsOptionsModalOpen] = useState(false)
  const [isOrdersModalOpen, setIsOrdersModalOpen] = useState(false)
  const [isBonusModalOpen, setIsBonusModalOpen] = useState(false)
  const [open360, setOpen360] = useState(false)
  const [isTiresModalOpen, setIsTiresModalOpen] = useState(false)
  const [openUnfrozeModal, setOpenUnfrozeModal] = useState(false)

  const hasBonusOrApprovedDiscount =
    (!!carForSale?.discountAmount &&
      !!carForSale?.discountApproveRopFullName) ||
    !!carForSale?.bonus

  const handleKebabClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleSppApprove = () => {
    funcs?.updateStatusTrack(110)
    setIsSppOpenModal(false)
  }

  const handleDiscountModalOpen = () => {
    setIsDiscountModalOpen(!isDiscountModalOpen)
    handleCloseMenu()
  }

  const openOnKolesa = () => {
    window.open(
      `https://kolesa.kz/a/show/${parseInt(car.kolesaDataId, 10)}`,
      '_blank'
    )
    handleCloseMenu()
  }

  const openOnAster = () => {
    window.open(
      `https://aster.kz/catalog/${parseInt(car.oneCId, 10)}`,
      '_blank'
    )
    handleCloseMenu()
  }

  return (
    <div className={classes.header}>
      {!isSelected && (
        <IconButton
          style={{
            color: GRAY_COLORS[400]
          }}
          onClick={onClose}
          size={'medium'}
        >
          <ChevronLeftIcon />
        </IconButton>
      )}

      <div className={classes.namePrice}>
        <div style={{ display: 'flex', gap: '1em', alignItems: 'center' }}>
          <Typography
            className={classes.heading}
          >{`${car.marka.name} ${car.model.name} ${car.year}`}</Typography>

          {user.role === SPP && car.cpTransactionType && (
            <Tooltip title="Тип выкупа">
              <Chip label={car.cpTransactionType} color="primary" />
            </Tooltip>
          )}
        </div>

        <div style={{ display: 'flex' }}>
          {hasBonusOrApprovedDiscount && (
            <div className={classes.price}>
              {carForSale?.discountValue?.toString()?.thousandSeparator() ||
                '-'}{' '}
              ₸
            </div>
          )}

          <div
            className={
              hasBonusOrApprovedDiscount ? classes.discount : classes.price
            }
          >
            {`${car?.price?.toString()?.thousandSeparator() || '-'} ₸`}
          </div>
        </div>
      </div>

      <IconButton
        style={{
          color: GRAY_COLORS[400]
        }}
        size={'medium'}
        aria-controls="header-dropdown"
      >
        <KebabVerticalIcon
          className={classes.kebab}
          onClick={handleKebabClick}
        />
      </IconButton>
      <Menu
        id="header-dropdown"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
      >
        {isSelected && (
          <>
            <MenuItem
              onClick={() => {
                setIsSppOpenModal(!isSppOpenModal)
                handleCloseMenu()
              }}
            >
              Отправить на согласование СПП
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleDiscountModalOpen()
              }}
            >
              Запросить скидку
            </MenuItem>

            {['ALA_BESAGASH'].includes(user.data.branch.code) && (
              <MenuItem
                onClick={() => {
                  setIsTiresModalOpen(!isTiresModalOpen)
                  handleCloseMenu()
                }}
              >
                Привязать продажу комплекта б.у. шин.
              </MenuItem>
            )}
          </>
        )}

        {!!car?.cashback && user?.role === 'MANAGER' && (
          <MenuItem
            onClick={() => {
              setIsBonusModalOpen(!isBonusModalOpen)
              handleCloseMenu()
            }}
          >
            Бонусы
          </MenuItem>
        )}

        {car.oneCId && (
          <MenuItem onClick={openOnAster}>Смотреть на aster.kz</MenuItem>
        )}

        {car.kolesaDataId && (
          <MenuItem onClick={openOnKolesa}>Смотреть на kolesa.kz</MenuItem>
        )}
        {car.has360ExteriorClose && (
          <MenuItem
            onClick={() => {
              setOpen360(true)
              handleCloseMenu()
            }}
          >
            Видеообзор
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            setIsOptionsModalOpen(!isOptionsModalOpen)
            handleCloseMenu()
          }}
        >
          Опции
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleOpen('techState', true)()
            handleCloseMenu()
          }}
        >
          Техсостояние
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleOpen('guarantee', true)()
            handleCloseMenu()
          }}
        >
          Информация по Гарантии
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleOpen('priceGraphics', true)()
            handleCloseMenu()
          }}
        >
          Сравнение цен авто на рынке
        </MenuItem>

        <MenuItem
          onClick={() => {
            setIsOrdersModalOpen(!isOrdersModalOpen)
            handleCloseMenu()
          }}
        >
          Заказ-наряды
        </MenuItem>
      </Menu>

      <Modal
        fullWidth
        open={isDiscountModalOpen}
        onClose={() => setIsDiscountModalOpen(false)}
      >
        <DiscountModal
          car={car}
          onClose={() => setIsDiscountModalOpen(false)}
        />
      </Modal>

      <Modal
        open={isTiresModalOpen}
        onClose={() => setIsTiresModalOpen(false)}
        fullWidth
      >
        <TiresModal onClose={() => setIsTiresModalOpen(false)} />
      </Modal>

      <Modal
        open={isOptionsModalOpen}
        onClose={() => setIsOptionsModalOpen(false)}
        fullWidth
      >
        <OptionsModal onClose={() => setIsOptionsModalOpen(false)} />
      </Modal>

      <Modal
        open={isOrdersModalOpen}
        onClose={() => setIsOrdersModalOpen(false)}
        fullScreen
      >
        <OrdersModal
          onClose={() => setIsOrdersModalOpen(false)}
          vin={car.vin}
        />
      </Modal>
      {open360 && (
        <Car360View vin={car.vin} onClose={() => setOpen360(false)} />
      )}
      <BonusHistory
        open={isBonusModalOpen}
        onClose={() => setIsBonusModalOpen(false)}
      />
      {user?.role === 'MANAGER' && (
        <UnFrozeModal
          title={'Чтобы использовать скидку вы должны разморозить бонусы!'}
          open={openUnfrozeModal}
          labelConfirm="Разморозить"
          onClose={() => setOpenUnfrozeModal(false)}
          onCancel={() => setOpenUnfrozeModal(false)}
        />
      )}
      <ActionModal
        open={isSppOpenModal}
        onClose={() => setIsSppOpenModal(false)}
        onCancel={() => setIsSppOpenModal(false)}
        onConfirm={handleSppApprove}
        title="Отправить на согласование СПП?"
      />
    </div>
  )
}
